import { useState } from "react";

const JoinModelHooks = () => {

    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const showModal = () => {
        setIsModalVisible(true);
       
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };
    return (
        {
            isModalVisible,
            setIsModalVisible,
            showModal,
            handleOk,
            handleCancel,
           
        }
    )
}

export default JoinModelHooks;